import { ChatIcon } from "../ui/icons/Icon";
import styles from "./ContactTagBadge.module.css";
import { Highlighted } from "./searchText";
import { colored, styleObject, tagStyle } from "./tagColor";

/**
 * La etiqueta (C15 1.14.3): una sola pieza en Etiquetas, Contactos y el Chat. Relleno y texto de su color de la paleta,
 * iguales en claro y en oscuro; sin color, neutra. Con `match`, la coincidencia de la búsqueda va en 700 y subrayada en
 * el color del texto de la etiqueta (C06 1.14.3).
 */
export function ContactTagBadge({ name, color, match }: { name: string; color?: string | null; match?: string | null }) {
  return (
    <span
      className={`contact-tag ${colored(color) ? "contact-tag-colored" : ""} ${styles.scope}`}
      style={styleObject(tagStyle(color))}
      title={name}
    >
      {match ? <Highlighted text={name} term={match} /> : name}
    </span>
  );
}

/**
 * Contenido de la píldora de una etiqueta en un filtro (C15 1.14.3): sin elegir, el punto de 10 px de su color a 6 px del
 * nombre; elegida, ✓ de 14 px. La píldora (.chip.c2-tag-chip) recibe el color con tagStyle y se pinta llena al elegirla.
 */
export function TagChipContent({ name, chosen }: { name: string; chosen: boolean }) {
  return (
    <>
      {chosen ? <ChatIcon name="check" /> : <span className="c2-tag-dot" aria-hidden="true"></span>}
      <span className="c2-tag-name">{name}</span>
    </>
  );
}
